import React from "react";
import "./PracticeLogo.styles.scss";

interface PracticeLogoProps {
  image: string;
  position?: "left" | "right" | "center";
}

const PracticeLogo = ({ image, position }: PracticeLogoProps) => {
  return (
    <div className={`practice-logo-preview ${position || ""}`}>
      <img src={image} alt={image} />
    </div>
  );
};

export default PracticeLogo;
